<template>
	<div class="vote-progress" :style="style"></div>
</template>

<script>
export default {
	name: 'VoteProgress',
	props: {
		height: {
			type: Number,
			default: 0.5
		}
	},
	computed: {
		progress() {
			return this.$store.getters['session/progress']
		},
		style() {
			const width = Math.round(this.progress * 100) + '%'
			const height = this.height + 'rem'
			return { width, height }
		}
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';

.vote-progress {
	background-color: $white;
	transition: width 0.25s ease-in-out;
}
</style>
